import { computed } from 'mobx';

import { AppFooterProps, AppHeaderProps } from '@teliaee/telia-megamenu';

import RootStore from '@stores/RootStore';
import LanguageStore, { Language } from '@stores/LanguageStore';
import RouteStore from '@stores/RouteStore';
import TranslateStore from '@stores/TranslateStore';
import SsoStore from '@stores/SsoStore';

import config from '@config';
import { LoginOptions } from '@config/Sso';

export default class MenuStore {
  private languageStore: LanguageStore;
  private routeStore: RouteStore;
  private translateStore: TranslateStore;
  private ssoStore: SsoStore;
  private appName: string = 'online-help';

  constructor(rootStore: RootStore) {
    this.languageStore = rootStore.languageStore;
    this.routeStore = rootStore.routeStore;
    this.translateStore = rootStore.translateStore;
    this.ssoStore = rootStore.ssoStore;
  }

  public handleNavigation = (event: any) => {
    this.routeStore.navigate(event);
  };

  public handleSectionChange = (section: string) => {
    const { closeSsoFrame, ssoFrameVisible } = this.ssoStore;
    if (ssoFrameVisible && section !== 'sso') {
      closeSsoFrame();
    }
  };

  public handleLangChange = (lang: Language): void => {
    this.languageStore.setLanguage(lang);
  };

  get app() {
    return this.appName;
  }

  @computed
  get lang() {
    return this.languageStore.currentLanguage;
  }

  @computed
  get translations() {
    return this.translateStore.currentTranslations || {};
  }

  get tier() {
    return config.componentTier || 'live';
  }

  @computed
  get currentPath() {
    return this.routeStore.pathname;
  }

  get ssoClient() {
    return this.ssoStore.ssoClient;
  }

  get ssoClientState() {
    return this.ssoStore.ssoClientState;
  }

  @computed
  get loginOptions(): LoginOptions {
    const { ssoFrameVisible, loginOptions } = this.ssoStore;
    return ssoFrameVisible ? loginOptions : undefined;
  }

  @computed
  get customerType() {
    return this.ssoStore.customer && this.ssoStore.customer.type;
  }

  get apiBaseUrl() {
    return config.apiBaseUrl;
  }

  public getFooterProps(): AppFooterProps {
    return {
      isSPA: true,
      isSSR: false,
      app: this.app,
      tier: this.tier,
      lang: this.lang,
      translations: this.translations,
      onPathChange: this.handleNavigation,
      apiBaseURL: this.apiBaseUrl,
    };
  }

  public getHeaderProps(): AppHeaderProps {
    return {
      isSPA: true,
      isSSR: false,
      app: this.app,
      tier: this.tier,
      lang: this.lang,
      apiBaseURL: this.apiBaseUrl,
      customerType: this.customerType,
      translations: this.translations,
      loginOptions: this.loginOptions,
      currentPath: this.currentPath,
      ssoClient: this.ssoClient,
      ssoClientState: this.ssoClientState,
      onSectionChange: this.handleSectionChange,
      onLangChange: this.handleLangChange,
      onPathChange: this.handleNavigation,
      disableSoftAuth: true
    };
  }
}
